import { Company } from 'shared';

export function isUserPartOfCompany(
  companyId: string,
  userCompanies: Company[],
) {
  return !!userCompanies?.find((company) => company._id === companyId);
}
